/* =======================================================
   ✅ INJIRI — IMAGE WITH TEXT (MODE A + MODE B) — FULL JS
   - Keeps existing animation/video logic
   - Adds Mode B mobile dots sync
   ======================================================= */
(function () {
  const stopVideo = (section) => {
    const videos = section.querySelectorAll("video");
    if (videos.length > 0) videos.forEach((video) => video.pause());
  };

  const playVideo = (section) => {
    const videos = section.querySelectorAll("video");
    if (videos.length > 0) videos.forEach((video) => video.play());
  };

  const setupModeBDots = (section) => {
    const modeb = section.querySelector("[data-iwt-modeb]");
    if (!modeb) return;

    const track = modeb.querySelector("[data-iwt-track]");
    const dotsWrap = modeb.querySelector("[data-iwt-dots]");
    if (!track || !dotsWrap) return;

    const items = Array.from(track.querySelectorAll(".iwt-modeb__item"));

    if (window.innerWidth >= 750 || items.length <= 1) {
      dotsWrap.innerHTML = "";
      return;
    }

    dotsWrap.innerHTML = "";

    const dots = items.map((_, idx) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "iwt-modeb__dot" + (idx === 0 ? " is-active" : "");
      button.setAttribute("aria-label", `Go to image ${idx + 1}`);
      button.addEventListener("click", () => {
        items[idx].scrollIntoView({
          behavior: "smooth",
          inline: "start",
          block: "nearest"
        });
      });
      dotsWrap.appendChild(button);
      return button;
    });

    const setActive = (index) => {
      dots.forEach((dot, i) => {
        dot.classList.toggle("is-active", i === index);
      });
    };

    const onScroll = () => {
      const trackRect = track.getBoundingClientRect();
      const centerX = trackRect.left + trackRect.width * 0.35;

      let nearest = 0;
      let nearestDist = Infinity;

      items.forEach((item, i) => {
        const rect = item.getBoundingClientRect();
        const itemX = rect.left + rect.width * 0.5;
        const dist = Math.abs(itemX - centerX);

        if (dist < nearestDist) {
          nearestDist = dist;
          nearest = i;
        }
      });

      setActive(nearest);
    };

    track.addEventListener("scroll", () => {
      window.requestAnimationFrame(onScroll);
    });

    onScroll();
  };

  const initSection = () => {
    const sections = document.querySelectorAll(".image-with-text-section");

    sections.forEach((section) => {
      const observeItems = section.querySelectorAll(".observe-me");

      if (observeItems.length > 0) {
        const observerOptions = {
          root: null,
          rootMargin: "0px",
          threshold: 0.2
        };

        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const target = entry.target;
              target.classList.add("is-inview");

              observer.unobserve(target);

              setTimeout(() => {
                target.classList.remove("is-inview");
                target.classList.remove("observe-me");
              }, 1250);
            }
          });
        }, observerOptions);

        observeItems.forEach((item) => observer.observe(item));
      }

      setupModeBDots(section);
    });

    const videoSectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) playVideo(entry.target);
        else stopVideo(entry.target);
      });
    });

    const videoResizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => playVideo(entry.target));
    });

    sections.forEach((section) => {
      videoSectionObserver.observe(section);
      videoResizeObserver.observe(section);
    });
  };

  initSection();

  document.addEventListener("shopify:section:load", function () {
    initSection();
  });

  window.addEventListener("resize", function () {
    document.querySelectorAll("[data-iwt-dots]").forEach((dots) => {
      dots.innerHTML = "";
    });
    initSection();
  });
})();